import request from '@/utils/request'

export function queryAll(data) {
    const params = {
        header: {},
        content: data
    }
    return request({
        url: '/fjtec-public-svc/col/queryAll',
        method: 'post',
        data: params
    })
}

export function queryColChildren(data) {
    const params = {
        header: {},
        content: data
    }
    return request({
        url: '/fjtec-public-svc/col/queryChildren',
        method: 'post',
        data: params
    })
}